















import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { IFormatObjectEditable } from "../../../../domain/editableFormat";
import { QuestionnaireGuidTree } from "../../../../domain/questionnaire";
import { FormatPageObjectEditableMixin } from "../mixins";
import { ObjectUpdatesPromptableMixin } from "./trackers/mixins";
import { default as QuestionnaireFormatObjectDrawer } from "./QuestionnaireFormatObjectDrawer.vue";

@Component({
  components: {
    QuestionnaireFormatObjectDrawer,
  }
})
export default class QuestionnaireFormatPageObjectDrawer extends Mixins(ModelEditableMixin, FormatPageObjectEditableMixin, ObjectUpdatesPromptableMixin) {
  @Prop({ default: () => [] as QuestionnaireGuidTree<IFormatObjectEditable>[] })
  treeItems: QuestionnaireGuidTree<IFormatObjectEditable>[];

  onMouseLeftDowned(event: PointerEvent) {
    // オブジェクトの選択はここでハンドリング.(伝搬も止めてる.)
    // (重なりがおかしかったらフォーマット編集の段階で気付けるよう必ず上のオブジェクトが拾う.本体で既存フォーマットを救うために行ってた複雑な制御はしない.)
    this.promptForObjectUpdates(event);
    if (!event.ctrlKey) {
      this.reselectObjects(this.object);
    } else {
      if (this.object.isSelected()) {
        this.deselectObjects(this.object);
      } else {
        this.selectObjects(this.object);
      }
    }
  }

  onMouseRightDowned(event: PointerEvent) {
    // 未選択の場合のみ選択する.選択状態のまま右クリックされた場合は何もしない
    this.promptForObjectUpdates(event);
    if (!this.object.isSelected()) {
      this.reselectObjects(this.object);
    }
    this.mouseRightDowned(event);
  }

  onMouseDownCaptured(event: PointerEvent) {
    this.mouseDownCaptured(this.object, event);
  }

  onDragHandleSelected(event: PointerEvent) {
    if (this.object.isSelected()) {
      // 選択状態のオブジェクトの子オブジェクトも追加選択する
      const childrenObjects = this.treeItems
        .filter(v => v.source.isSelected())
        .map(v => v.toChildren())
        .reduce((c, v) => c.concat(v))
        .map(v => v.source);
      this.selectObjects(...childrenObjects);
    } else {
      // 選択状態でないオブジェクトがドラッグされた場合、そのオブジェクトと子オブジェクトを再選択する
      const childrenObjects = this.treeItems
        .filter(v => v.source === this.object)
        .map(v => v.toChildren())
        .reduce((c, v) => c.concat(v))
        .map(v => v.source);
      this.reselectObjects(this.object, ...childrenObjects);
    }
    this.dragHandleSelected(this.object, event);
  }

  @Emit()
  mouseRightDowned(event: PointerEvent) {}

  @Emit()
  mouseDownCaptured(source: IFormatObjectEditable, event: PointerEvent) {}

  @Emit()
  dragHandleSelected(source: IFormatObjectEditable, event: PointerEvent) {}
}
